import { useState } from "react";
import BackgroundLayer from "@/components/BackgroundLayer";
import RadioGroup from "@/components/RadioGroup";
import { CHOICE_SHORT, THRESHOLD_LABELS, getFeelingMessage } from "@/data/exhaleData";
import { ListenButton } from "@/components/AudioControls";

const FEELING_OPTIONS = [
  { value: "frustrated", label: "Frustrated" },
  { value: "relieved", label: "Relieved" },
  { value: "uncertain", label: "Uncertain" },
  { value: "confident", label: "Confident" },
  { value: "surprised", label: "Surprised" },
];

export default function SideBySide({ sessionData, updateSession, onNext, onBack, stageIndex }) {
  const [feelingSelected, setFeelingSelected] = useState(false);
  const thresholdDisplay = THRESHOLD_LABELS[sessionData.threshold] || sessionData.threshold;
  const feelingMsg = sessionData.feeling ? getFeelingMessage(sessionData.feeling) : "";

  const handleFeelingSelect = (val) => {
    updateSession("feeling", val);
    setFeelingSelected(true);
  };

  return (
    <div className="page-wrapper" data-testid="side-by-side-page">
      <BackgroundLayer image="/images/page6_bg.jpg" />
      <div className="content-layer" style={{ minHeight: "100vh", minHeight: "100dvh" }}>
        <div className="page-content" style={{ paddingTop: 60, paddingBottom: 80 }}>

          {/* Side-by-side section */}
          <div className="section-label animate-in" style={{ marginBottom: 12 }}>03: Side-by-Side</div>
          <div className="animate-in animate-in-d1" style={{ marginBottom: 20 }}>
            <ListenButton stageIndex={stageIndex} />
          </div>

          <div className="section-text-block">
            <p className="body-text animate-in animate-in-d1">
              Here's a side by side of what happened. Have a look. Don't file it away just yet at that half second you see it. Let the moment open before it's close. How do you feel?
            </p>
          </div>

          <p className="animate-in animate-in-d2" style={{ color: "rgba(184,212,208,0.6)", fontSize: "0.9rem", marginBottom: 20, fontWeight: 400 }}>
            Your stated threshold: {thresholdDisplay}
          </p>

          {/* Side by side table */}
          <div className="side-by-side animate-in animate-in-d3">
            <div className="sbs-header">Your Path</div>
            <div className="sbs-header">Actual Market</div>

            <div className="sbs-row">
              <div className="sbs-cell user-choice">
                <div style={{ fontSize: "0.68rem", letterSpacing: "0.12em", color: "rgba(184,212,208,0.35)", marginBottom: 4 }}>September 2008</div>
                {CHOICE_SHORT[sessionData.e1] || "—"}
              </div>
              <div className="sbs-cell market">S&P: -4.7%</div>
            </div>

            <div className="sbs-row">
              <div className="sbs-cell user-choice">
                <div style={{ fontSize: "0.68rem", letterSpacing: "0.12em", color: "rgba(184,212,208,0.35)", marginBottom: 4 }}>October 2008</div>
                {CHOICE_SHORT[sessionData.e2] || "—"}
              </div>
              <div className="sbs-cell market">S&P: -16.9%</div>
            </div>

            <div className="sbs-row">
              <div className="sbs-cell user-choice">
                <div style={{ fontSize: "0.68rem", letterSpacing: "0.12em", color: "rgba(184,212,208,0.35)", marginBottom: 4 }}>March 2009</div>
                {CHOICE_SHORT[sessionData.e3] || "—"}
              </div>
              <div className="sbs-cell market">S&P: -56.8% total</div>
            </div>
          </div>

          <p className="recovery-line animate-in animate-in-d4">
            Your portfolio fully recovery: 2013, and +200% by 2020
          </p>

          {/* How do you feel — closer to table */}
          <div className="section-label animate-in animate-in-d5" style={{ marginBottom: 16, marginTop: 16 }}>04: How Do You Feel</div>

          <div className="animate-in animate-in-d6">
            <RadioGroup
              name="feeling"
              options={FEELING_OPTIONS}
              selected={sessionData.feeling}
              onSelect={handleFeelingSelect}
            />
          </div>

          {/* Feeling message */}
          {feelingMsg && (
            <div className="feeling-message" data-testid="feeling-message">
              {feelingMsg}
            </div>
          )}

          {/* Audio after feeling response */}
          {feelingSelected && (
            <div className="animate-in" style={{ marginTop: 16, marginBottom: 8 }}>
              <ListenButton audioKey="5b" />
            </div>
          )}

          {/* Post-feeling guidance */}
          {feelingSelected && (
            <div className="animate-in" style={{ marginTop: 24 }}>
              <p className="body-text">
                Now that you registered what popped up. Have another look at the SIDE-BY-SIDE. Think through it. Have an inner exhale before you hit the EXHALE.
              </p>
              <div className="nav-buttons" style={{ marginTop: 32 }}>
                <button className="nav-back" onClick={onBack} data-testid="back-btn">Back</button>
                <button
                  className="cta-pill"
                  onClick={onNext}
                  data-testid="exhale-btn"
                >
                  Exhale
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
